<template>
  <form
    :action="params.action"
    :method="params.method"
  >
    <GuButton type="submit" variant="link" class="p-0">{{ params.text }}</GuButton>
  </form>
</template>

<script setup>
import { GuButton } from '@shared/gu-components/button'

defineProps({
  params: {
    type: Object,
    default: () => {},
  },
})
</script>
